<template>
  <div>
    <i-container class="_margin-bottom-1-2">
      <i-pagination size="sm" id="pagination" v-model="currentPage" :items=totalItems :items-per-page="itemsPerPage"
                    @change="paginationChanged"></i-pagination>
    </i-container>
    <i-container>
      <i-table striped responsive>
        <thead>
        <tr>
          <td>COSPAR</td>
          <td>H [mag]</td>
          <td>Aρ [m<sup>2</sup>]</td>
          <td>Beta [-]</td>
          <td>Data</td>
          <td>Phase Curve</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in databaseSlice">
          <td class="_align-middle">
            <i-tooltip variant="light" placement="right">
              <span class="dotted-underline">{{row["cospar"]}}</span>
              <template slot="body">{{row["object-name"]}}</template>
            </i-tooltip>
          </td>
          <td class="_align-middle">{{Math.round(row["Hejduk_med_AbsMag"] * 1000) / 1000}}</td>
          <td class="_align-middle _width-25">{{Math.round(row["Hejduk_med_AreaRo"] * 1000) / 1000}}</td>
          <td class="_align-middle _width-25">{{Math.round(row["Hejduk_med_beta"] * 1000) / 1000}}</td>
          <td class="_align-middle">
            <i-button outline variant="secondary" @click="showModal(row)">Details</i-button>
          </td>
          <td class="_display-xs-none _display-sm-none _display-md-table-cell _height-10 _width-15 _margin-right-1">
            <i-tooltip :arrow=false trigger="click" placement="left" variant="light"
                       :popperOptions="{positionFixed: true}">
              <img class="lazyload image -thumbnail _width-50" alt="Phase curve thumbnail"
                   v-bind:src="require('./../assets/raw_data/images/'+row['points_picture'])"/>
              <template slot="body">
                <div class="_display-flex _flex-direction-column _text-center">
                  <span class="_font-weight-semibold _font-size-lg">{{row["norad"]}}</span>
                  <img class="pc_image lazyload image" alt="Phase curve real image"
                       v-bind:src="require('./../assets/raw_data/images/'+row['points_picture'])"/>
                </div>
              </template>
            </i-tooltip>
          </td>
          <td class="_align-middle _display-xs-table-cell _display-md-none _display-lg-none _display-xl-none">
            <a v-bind:href="require('./../assets/raw_data/images/'+row['points_picture'])" target="_blank">Image</a>
          </td>
        </tr>
        </tbody>
      </i-table>
      <i-pagination size="sm" id="pagination" v-model="currentPage" :items=totalItems :items-per-page="itemsPerPage"
                    @change="paginationChanged"></i-pagination>
    </i-container>
    <i-modal id="modal-phase" variant="secondary" v-model="visible[0]" size="lg" @hide="visible = [false, '']">
      <template slot="header">Details for object with COSPAR: {{visible[1]["cospar"]}}</template>
      <i-container class="_display-xs-none _display-sm-none">
        <i-row class="_text-center">
          <i-column xs="12" id="modal-phase-image-place" class="_margin-bottom-1">
            <!--injected image-->
          </i-column>
        </i-row>
        <i-row>
          <i-column xs="6" md="3">
            Object name:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["object-name"]}}
          </i-column>
          <i-column xs="6" md="3">
            Source
          </i-column>
          <i-column xs="6" md="3" id="source-column">
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            COSPAR:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["cospar"]}}
          </i-column>
          <i-column xs="6" md="3">
            Data source:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["data_source"]}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Object type:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["object-type"]}}
          </i-column>
          <i-column xs="6" md="3">
            H [mag]
          </i-column>
          <i-column xs="6" md="3">
            {{parseFloat(visible[1]["Hejduk_med_AbsMag"]).toFixed(2)}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            NORAD:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["norad"]}}
          </i-column>
          <i-column xs="6" md="3">
            H error [mag]
          </i-column>
          <i-column xs="6" md="3">
            {{parseFloat(visible[1]["Hejduk_med_AbsMag_sigma"]).toFixed(2)}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Orbital period:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["orbital-period"]}}
          </i-column>
          <i-column xs="6" md="3">
            Pb [mag]
          </i-column>
          <i-column xs="6" md="3">
            {{Math.abs(visible[1]["Hejduk_predictionBand_upper_AbsMag"] - visible[1]["Hejduk_med_AbsMag"]).toFixed(2)}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Inclination [deg]:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["inclination"]}}
          </i-column>
          <i-column xs="6" md="3">
            Aρ [m<sup>2</sup>]
          </i-column>
          <i-column xs="6" md="3">
            {{parseFloat(visible[1]["Hejduk_med_AreaRo"]).toFixed(2)}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Perigee [km]:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["perigee"]}}
          </i-column>
          <i-column xs="6" md="3">
            Aρ error[m<sup>2</sup>]
          </i-column>
          <i-column xs="6" md="3">
            {{parseFloat(visible[1]["Hejduk_med_AreaRo_sigma"]).toFixed(2)}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Apogee [km]:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["apogee"]}}
          </i-column>
          <i-column xs="6" md="3">
            Beta [-]
          </i-column>
          <i-column xs="6" md="3">
            {{parseFloat(visible[1]["Hejduk_med_beta"]).toFixed(2)}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Decayed:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["decayed"]}}
          </i-column>
          <i-column xs="6" md="3">
            Beta error [-]
          </i-column>
          <i-column xs="6" md="3">
            {{parseFloat(visible[1]["Hejduk_med_beta_sigma"]).toFixed(2)}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Number of points
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["Hejduk_med_no_of_points"]}}
          </i-column>
          <i-column xs="6" md="3">
            MJD last
          </i-column>
          <i-column xs="6" md="3">
            {{parseFloat(visible[1]["mjd_max"]).toFixed(2)}}
          </i-column>
        </i-row>
      </i-container>
      <i-container class="_display-xs-block _display-sm-block _display-md-none _display-lg-none _display-xl-none">
        <i-row>
          <i-column xs="12" id="modal-phase-image-place-res" class="_margin-bottom-1">
            <!--injected image-->
          </i-column>
          <i-column xs="6">
            Object name:
          </i-column>
          <i-column xs="6" class="_align-bottom">
            {{visible[1]["object-name"]}}
          </i-column>
          <i-column xs="6">
            COSPAR:
          </i-column>
          <i-column xs="6">
            {{visible[1]["cospar"]}}
          </i-column>
          <i-column xs="6" md="3">
            Object type:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["object-type"]}}
          </i-column>
          <i-column xs="6">
            NORAD:
          </i-column>
          <i-column xs="6">
            {{visible[1]["norad"]}}
          </i-column>
          <i-column xs="6">
            Orbital period:
          </i-column>
          <i-column xs="6">
            {{visible[1]["orbital-period"]}}
          </i-column>
          <i-column xs="6">
            Inclination [deg]:
          </i-column>
          <i-column xs="6">
            {{visible[1]["inclination"]}}
          </i-column>
          <i-column xs="6">
            Perigee [km]:
          </i-column>
          <i-column xs="6">
            {{visible[1]["perigee"]}}
          </i-column>
          <i-column xs="6">
            Apogee [km]:
          </i-column>
          <i-column xs="6">
            {{visible[1]["apogee"]}}
          </i-column>
          <i-column xs="6">
            Decayed:
          </i-column>
          <i-column xs="6" class="_margin-bottom-xs-1-2 _margin-bottom-sm-1-2">
            {{visible[1]["decayed"]}}
          </i-column>

          <i-column xs="6">
            Source
          </i-column>
          <i-column xs="6" id="source-column">
          </i-column>
          <i-column xs="6">
            Data source:
          </i-column>
          <i-column xs="6">
            {{visible[1]["data_source"]}}
          </i-column>
          <i-column xs="6">
            H [mag]
          </i-column>
          <i-column xs="6">
            {{parseFloat(visible[1]["Hejduk_med_AbsMag"]).toFixed(2)}}
          </i-column>
          <i-column xs="6">
            H error [mag]
          </i-column>
          <i-column xs="6">
            {{parseFloat(visible[1]["Hejduk_med_AbsMag_sigma"]).toFixed(2)}}
          </i-column>
          <i-column xs="6">
            Pb [mag]
          </i-column>
          <i-column xs="6">
            {{Math.abs(visible[1]["Hejduk_predictionBand_upper_AbsMag"] - visible[1]["Hejduk_med_AbsMag"]).toFixed(2)}}
          </i-column>
          <i-column xs="6">
            Aρ [m<sup>2</sup>]
          </i-column>
          <i-column xs="6">
            {{parseFloat(visible[1]["Hejduk_med_AreaRo"]).toFixed(2)}}
          </i-column>
          <i-column xs="6">
            Aρ error[m<sup>2</sup>]
          </i-column>
          <i-column xs="6">
            {{parseFloat(visible[1]["Hejduk_med_AreaRo_sigma"]).toFixed(2)}}
          </i-column>
          <i-column xs="6">
            Beta [-]
          </i-column>
          <i-column xs="6">
            {{parseFloat(visible[1]["Hejduk_med_beta"]).toFixed(2)}}
          </i-column>
          <i-column xs="6">
            Beta error [-]
          </i-column>
          <i-column xs="6">
            {{parseFloat(visible[1]["Hejduk_med_beta_sigma"]).toFixed(2)}}
          </i-column>
          <i-column xs="6">
            Number of points
          </i-column>
          <i-column xs="6">
            {{visible[1]["Hejduk_med_no_of_points"]}}
          </i-column>
          <i-column xs="6">
            MJD last
          </i-column>
          <i-column xs="6">
            {{parseFloat(visible[1]["mjd_max"]).toFixed(2)}}
          </i-column>

        </i-row>
      </i-container>
    </i-modal>
  </div>
</template>

<script>
  //TODO - treba vymenit period-error za perr
  export default {
    name: "LCDContent",
    data() {
      return {
        currentPage: 1,
        itemsPerPage: 20,
        database: undefined,
        databaseSlice: undefined,
        visible: [false, ""]
      }
    },
    props: {
      totalItems: {
        type: Number
      },
      filteredDatabase: {}
    },
    methods: {
      paginationChanged(item) {
        this.sliceTheDB();
      },
      sliceTheDB() {
        let filteredJson = {};

        this.database = this.filteredDatabase;

        let counter = 1;
        let lowerLimit = this.currentPage * this.itemsPerPage - this.itemsPerPage;
        let higherLimit = this.currentPage * this.itemsPerPage;

        for (let i in this.database) {
          let obj = this.database[i];
          if (counter > lowerLimit && counter <= higherLimit) {
            filteredJson[counter] = obj;
          }
          counter++;
        }
        // console.log(Object.keys(filteredJson).length)
        this.databaseSlice = filteredJson;
      },
      showModal(row) {
        this.visible = [true, row];

        let modalCol = document.getElementById("modal-phase-image-place");
        let modalColRes = document.getElementById("modal-phase-image-place-res");
        if (row['points_picture_fit'] !== undefined) {
          let path = require('./../assets/raw_data/images/' + row['points_picture_fit']);
          modalCol.innerHTML = "<img class='image -responsive _max-width-100' src='" + path + "' alt='Phase file'/>";
          modalColRes.innerHTML = "<img class='image -responsive _max-width-100' src='" + path + "' alt='Phase file'/>";
        } else {
          modalCol.innerHTML = "<p class='_text-warning'>No phase curve could be generated!</p>";
          modalColRes.innerHTML = "<p class='_text-warning'>No phase curve could be generated!</p>";
        }

        let sourceCol = document.getElementById("source-column");
        let lcFilePath = '/static/data/' + row['data_file'];

        sourceCol.innerHTML = "<a href='" + lcFilePath + "' class='_margin-right-1-2' target='_blank'>PC</a>"
      }
    },
    created: function () {
    },
    mounted: function () {
      this.database = this.filteredDatabase;
      this.sliceTheDB();
    },
    watch: {
      filteredDatabase: function (newVal, oldVal) {
        this.sliceTheDB();
      }
    }
  }
</script>

<style scoped>
  .pagination >>> .item, .pagination >>> .item.-disabled:hover {
    background-color: transparent;
    border-color: #1684a9;
    color: #1684a9;
  }

  .pagination >>> .item:hover {
    background-color: #1684a9;
    color: white;
  }

  .pagination >>> .item.-active {
    background-color: #1684a9 !important;
    color: white;
  }

  .pagination >>> .item.-previous {
    margin-left: 0 !important;
  }

  ._height-10 {
    height: 10% !important;;
  }

  ._width-10 {
    width: 10% !important;
  }

  ._width-15 {
    width: 15% !important;
  }

  img:hover {
    cursor: pointer;
  }

  .modal >>> .body {
    border-bottom-left-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  #modal-phase-image-place >>> img {
    max-height: 50vh;
    max-width: 50vw;
  }

  .dotted-underline {
    text-decoration-line: underline;
    text-decoration-style: dotted;
  }

  .row >>> .column:nth-child(odd) {
    font-weight: 700;
  }

  #modal-phase >>> .body {
    overflow-y: auto;
    max-height: 50vh;
    border-bottom-left-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  #modal-phase >>> .body {
    max-height: calc(var(--vh, 1vh) * 50);
  }

  .pc_image {
    max-width: 875px;
    max-height: 656px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Content.vue